import React from "react";
import { Form, Label } from "semantic-ui-react";

// todo move to actual formik types instead of any

const CallableInput = ({
  field,
  form: { errors, touched, setFieldValue },
  label,
  inline,
  ...props
}: any) => {
  return (
    <Form.Field>
      {label && <label>{label}</label>}
      <input
        onBlur={(e) => setFieldValue(field.name, e.currentTarget.value)}
        name={field.name}
        defaultValue={field.value}
        {...props}
      />
      {touched[field.name] && errors[field.name] && (
        <Label basic pointing color="red">
          {errors[field.name]}
        </Label>
      )}
    </Form.Field>
  );
};

export default CallableInput;
